export default (originalValue => Math.round(parseFloat(originalValue) * 100));
